export default __webpack_public_path__ + "static/media/lottery-post.0a104211.png";